var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5493 47.6L37.6929 23.6C37.385 23.0667 36.6152 23.0667 36.3072 23.6L22.4508 47.6C22.1429 48.1333 22.5278 48.8 23.1437 48.8H50.8565C51.4723 48.8 51.8572 48.1333 51.5493 47.6ZM40.4642 22C38.9246 19.3333 35.0756 19.3333 33.536 22L19.6796 46C18.14 48.6667 20.0645 52 23.1437 52H50.8565C53.9357 52 55.8602 48.6667 54.3206 46L40.4642 22ZM38.4792 28.8H35.5207C34.9234 28.8 34.4593 29.3202 34.5272 29.9136L35.8986 41.9136C35.9563 42.4187 36.3838 42.8 36.8921 42.8H37.1077C37.616 42.8 38.0435 42.4187 38.1012 41.9136L39.4727 29.9136C39.5406 29.3202 39.0765 28.8 38.4792 28.8ZM37 46.9999C37.9941 46.9999 38.8 46.194 38.8 45.1999C38.8 44.2058 37.9941 43.3999 37 43.3999C36.0058 43.3999 35.2 44.2058 35.2 45.1999C35.2 46.194 36.0058 46.9999 37 46.9999Z",
    fill: "#FFC924"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "#FFC924"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f4b2e6c14e021a8e42f289b301ed9f19.svg";
export { ForwardRef as ReactComponent };